import {
  formatDate,
  createReducer,
  createRequestReducer
} from 'utils';

import {
  CLEAR_POSTS_SEARCH,
  GET_POSTS_SEARCH
} from './constants';

const initialState = {
  results: [],
  isFetching: false,
  fetchingErrors: null
};

function formatNewsDate(post) {
  if (!post) {
    return post;
  }

  return Object.assign({}, post, {
    dateDisplay: formatDate(post.datePublished)
  });
}

export default createReducer(initialState, {
  [GET_POSTS_SEARCH]: (state, action) => {
    return createRequestReducer(state, action, {
      SEND: (state) =>
        Object.assign(state, {
          isFetching: true,
          fetchingErrors: null
        }),

      SUCCESS: (state, action) => {
        const { results, ...props } = action.request.response;

        const items = state.results.slice(0);
        items.push(...results.map(formatNewsDate));

        return Object.assign(state, {
          ...props,
          results: items,
          isFetching: false,
          fetchingErrors: null
        });
      },

      FAIL: (state, action) =>
        Object.assign(state, {
          isFetching: false,
          fetchingErrors: action.request.error
        })
    });
  },

  [CLEAR_POSTS_SEARCH]: (state, action) => {
    return initialState;
  }
});



// WEBPACK FOOTER //
// ./src/redux/PostsSearch/reducer.js